import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectLocations = createSelector(
  [
    (store: RootState) => store.userAuthentication.user,
    (store: RootState) => store.supervisorHome.locationSearchText,
    (store: RootState) => store.supervisorHome.documents,
  ],
  (user, searchText, documents) =>
    [...(user?.locations || [])]
      .filter(({ name }) => name?.toLowerCase().includes(searchText.toLowerCase() || ""))
      .sort((a, b) => {
        if ((a.name || "") > (b.name || "")) {
          return 1;
        }
        return -1;
      })
      .map((item) => ({
        ...item,
        warnings: documents.filter(({ locations = [] }) => locations.includes(item.id || "")),
      }))
);
